import React from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Layout>
      <section className="section">
        <div className="container">
          <div className="card" style={{padding:16}}>
            <h1 style={{margin:"0 0 8px"}}>404</h1>
            <p className="pMuted">Səhifə tapılmadı.</p>
            <Link className="btn btnPrimary" to="/">Ana səhifə</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
